import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { useLang } from "./LangContext";
import { Reveal } from "./Reveal";

function useCountUp(target, run) {
  const [value, setValue] = useState(0);
  useEffect(() => {
    if (!run) return;
    let raf;
    const start = performance.now();
    const dur = 1600;
    const tick = (now) => {
      const p = Math.min((now - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setValue(Math.round(eased * target));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [run, target]);
  return value;
}

export default function Network() {
  const { t } = useLang();
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-20%" });
  const count = useCountUp(parseInt(t.network.number, 10), inView);

  return (
    <section
      ref={ref}
      data-testid="network-section"
      className="border-t border-border px-6 py-28 md:px-12 md:py-44"
    >
      <div className="mb-8 flex items-center justify-between">
        <span className="label">05 — Network</span>
        <span className="label">BOG / CO</span>
      </div>

      <div className="grid grid-cols-1 items-end gap-10 md:grid-cols-12">
        <div className="md:col-span-8">
          <div
            data-testid="network-number"
            className="font-display font-medium leading-[0.78] tracking-tighter text-[38vw] md:text-[26vw]"
          >
            {count}
            <span className="text-accent">{t.network.suffix}</span>
          </div>
        </div>
        <div className="md:col-span-4 md:pb-8">
          <Reveal delay={0.15}>
            <p className="font-display text-2xl font-medium leading-tight tracking-tight md:text-3xl">
              {t.network.text}
            </p>
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-muted-foreground">
              {t.network.support}
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
